module.exports = __webpack_public_path__ + "static/img/kjdy15.625f183.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/kjdy15.png
// module id = 137
// module chunks = 0